import { useContext } from 'react';

import {
  mapApiAutoscalerBehaviorToFormModel,
  mapApiMetricsToFormModel,
} from '../../../../../_utils';
import { SettingRow } from '../../../../../_woop-settings/_components/layout/SettingRow';
import { WorkloadDetailsContext } from '../../../../_context';
import { HorizontalRightsizingFormModelV2 } from '../../../_types';
import { OverrideGroupOverrideButton } from '../../override/OverrideGroupOverrideButton';

export const HpaOverrideSettingsRow = () => {
  const { workload } = useContext(WorkloadDetailsContext);
  const hpaSettings = workload?.verticalScalingPolicy?.hpaSettings;
  const { isNamespaceWritable } = useContext(WorkloadDetailsContext);
  const isNamespaceWritableForWorkload = isNamespaceWritable(
    workload?.namespace
  );

  // Hide when workload is managed by annotations
  if (
    workload?.isManagedByAnnotations ||
    !hpaSettings ||
    !isNamespaceWritableForWorkload
  ) {
    return null;
  }

  return (
    <SettingRow
      title="Override HPA object"
      description="Horizontal optimization can only be overridden as an object"
      testId="hpa-override-settings-row"
      actionButton={
        <OverrideGroupOverrideButton<
          Omit<HorizontalRightsizingFormModelV2, 'enabled'>
        >
          onRevert={() => {
            const { minReplicas, maxReplicas, metrics, behavior } =
              hpaSettings.nativeHpaSpec;

            return {
              hpaSettings: {
                basicBehavior: {
                  minReplicas: minReplicas,
                  maxReplicas: maxReplicas,
                },
                metrics: mapApiMetricsToFormModel(metrics),
                autoscalerBehavior:
                  mapApiAutoscalerBehaviorToFormModel(behavior),
              },
            };
          }}
        />
      }
      noBorderTop
    />
  );
};
